import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { clientTimeline, SSE_UPDATE_SNAPSHOT_TIMELINE_GENERATION_PROGRESS } from './types';

import { requestClientTimelineSuccess, requestClientTimelineFailure } from './reducer';

import { requestClientTimeline } from './actions';

import { requestSnapshotSuccess } from '../client/actions';

const logger = new Logger('Saga:Monitor:Timeline');

export function* requestClientTimelineSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');
  const { entityId, promise } = action;

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.monitor.snapshot_timeline', {
        entityId,
      }),
    );

    const snapshotsLength = response.data?.snapshots?.length;
    if (snapshotsLength) {
      const latestSnapshot = response.data.snapshots?.sort(
        (a, b) => new Date(a.startDate) - new Date(b.startDate),
      )[snapshotsLength - 1];

      yield put(requestSnapshotSuccess({ response: latestSnapshot }));
    }

    yield put(requestClientTimelineSuccess(response.data));
    promise && promise.resolve();
  } catch (error) {
    logger.error('Failed to request client timeline with the following error', error);
    yield put(requestClientTimelineFailure(error));
  }
}

export function* requestUpdateSnapshotTimelineSaga(action) {
  const entityId = action?.payload?.entityId;
  const percentage = action?.payload?.percentage;

  if (percentage === 100) {
    yield put(
      requestClientTimeline(entityId, {
        resolve: () => null,
        reject: () => null,
      }),
    );
  }
}

export default function* timelineSaga() {
  return yield all([
    takeLatest(clientTimeline.request, requestClientTimelineSaga),
    takeLatest(SSE_UPDATE_SNAPSHOT_TIMELINE_GENERATION_PROGRESS, requestUpdateSnapshotTimelineSaga),
  ]);
}
